<template>
<div class="filters-background" v-show="value">
  <div class="filters-content">
    <div class="filters-head">
      <div class="filters-title">
        FILTERS ({{Object.keys(targets).length}} Targets, {{Object.keys(compounds).length}} Compounds)
      </div>
      <div class="filters-close" @click="close"><i class="el-icon-close"></i></div>
    </div>
    <div class="filters-body">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-label">
            FP2 Similarity
          </div>
          <div>
            <el-input-number v-model="simCutoff" :precision="2" :step="0.05" :min="0" :max="0.95"></el-input-number>
          </div>
        </div>

        <!-- <div class="filter-row">
          <div class="filter-label">
            Databases
          </div>
          <div class="filter-databases">
            <div><input type="checkbox" value="CHEMBL"      id="checkbox-chembl" v-model="databases"><label for="checkbox-chembl">CHEMBL</label></div>
            <div><input type="checkbox" value="Metabolites" id="checkbox-metabolites" v-model="databases"><label for="checkbox-metabolites">HMDB</label></div>
            <div><input type="checkbox" value="Zinc"        id="checkbox-zinc" v-model="databases"><label for="checkbox-zinc">ZINC</label></div>
          </div>
        </div> -->

        <div class="filter-row">
          <div class="filter-label">
            Hide compounds that have no targets?
          </div>
          <div>
            <el-switch v-model="hideNullCompounds"></el-switch>
          </div>
        </div>

        <div class="filter-row">
          <div class="filter-label">
            Hide own targets of the query compound?
          </div>
          <div>
            <el-switch v-model="hideOwnTargets"></el-switch>
          </div>
        </div>
      </div>

      <div v-if="databases.includes('CHEMBL')" class="filter-card">
        <div class="filter-row">
          <div class="filter-label">
            Activity
          </div>
          <div class="filter-activity">
            <div class="filter-activity-row">
              Allow All Activities &nbsp; <el-switch v-model="allowAllActivities"></el-switch>
            </div>
            <template v-if="!allowAllActivities">
              <div class="filter-activity-row filter-activity-head">
                <div class="filter-activity-type">Assay Type</div>
                <div class="filter-activity-check">Activate</div>
                <!-- <div class="filter-activity-allow-nan">Allow NaN</div> -->
                <div class="filter-activity-slider">Range</div>
                <div>Units</div>
              </div>
              <div v-for="(assayType, type, itype) in assayRange" :key="itype">
                <div class="filter-activity-row" v-for="(range, unit, iunit) in assayType" :key="iunit">
                  <div class="filter-activity-type">{{range.type}}</div>
                  <div class="filter-activity-check"><el-switch v-model="range.active" @change="applyAssayRange"></el-switch></div>
                  <!-- <div class="filter-activity-allow-nan"><el-switch v-model="range.allowNaN" @change="applyAssayRange"></el-switch></div> -->
                  <template v-if="range.active">
                    <div class="filter-activity-slider"><el-slider v-model="range.range" @change="applyAssayRange" range :step="range.step" :min="range.min" :max="range.max"></el-slider></div>
                    <div class="filter-activity-input"><el-input size="mini" v-model="range.range[0]" @change="applyAssayRange"></el-input></div>
                    <div>-</div>
                    <div class="filter-activity-input"><el-input size="mini" v-model="range.range[1]" @change="applyAssayRange"></el-input></div>
                    <div>&nbsp;{{range.unit=='null'?'':range.unit}}</div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="filter-row">
          <div class="filter-label">
            Target Type
          </div>
          <div>
            <div v-for="(val, type, ind) in targetTypes" :key="ind" :class="[(val ? 'filter-switch-on' : 'filter-switch-off'), 'filter-switch']" @click="targetTypes[type]=!targetTypes[type]">
              {{type}}
            </div>
            <div class="filter-switch-select-all" @click="selectAllTargetTypes()">
              Select All
            </div>
            <div class="filter-switch-select-all" @click="selectNoneTargetTypes()">
              Select None
            </div>
            <div style="clear:both"></div>
          </div>
        </div>

        <div class="filter-row">
          <div class="filter-label">
            Target Species
          </div>
          <div>
            <div v-for="(val, species, ind) in targetSpecies" :key="ind" :class="[(val ? 'filter-switch-on' : 'filter-switch-off'), 'filter-switch']" @click="targetSpecies[species]=!targetSpecies[species]">
              {{species}}
            </div>
            <div class="filter-switch-select-all" @click="selectAllTargetSpecies()">
              Select All
            </div>
            <div class="filter-switch-select-all" @click="selectNoneTargetSpecies()">
              Select None
            </div>
            <div style="clear:both"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import { bus } from '../bus.js'
import { mapGetters } from 'vuex'

export default {
  name: 'Filters',

  data () {
    return {
      compound: '',
      compareVisible: false,
      resultToCompare: '',
      databases: ['CHEMBL', 'Metabolites'],
      allowAllActivities: false,
      assayRange: []
    }
  },

  props: [ 'value' ],

  computed: {
    ...mapGetters([
      'targets',
      'compounds',
      'allTargetTypes',
      'allTargetSpecies',
      'allAssayTypes'
    ]),

    simCutoff: {
      get () {
        return this.$store.state.minimalCompoundSimilarity
      },

      set (v) {
        this.$store.commit('set', {minimalCompoundSimilarity: v})
      }
    },

    hideNullCompounds: {
      get () {
        return this.$store.state.hideNullCompounds
      },

      set (v) {
        this.$store.commit('set', {hideNullCompounds: v})
      }
    },

    hideOwnTargets: {
      get () {
        return this.$store.state.hideOwnTargets
      },

      set (v) {
        this.$store.commit('set', {hideOwnTargets: v})
      }
    },

    targetTypes: {
      get () {
        let r = {}
        let isTargetTypesInitiated = true
        for (let type of this.$store.getters.allTargetTypes) {
          if (!(type in this.$store.state.targetTypes)) {
            r[type] = false
            isTargetTypesInitiated = false
          } else {
            r[type] = this.$store.state.targetTypes[type]
          }
        }
        if (!isTargetTypesInitiated) {
          this.$store.commit('set', {targetTypes: r})
        }
        return this.$store.state.targetTypes
      },

      set (v) {
        this.$store.commit('set', {targetTypes: v})
      }
    },

    targetSpecies: {
      get () {
        let r = {}
        let isTargetSpeciesInitiated = true
        for (let species of this.$store.getters.allTargetSpecies) {
          if (!(species in this.$store.state.targetSpecies)) {
            r[species] = false
            isTargetSpeciesInitiated = false
          } else {
            r[species] = this.$store.state.targetSpecies[species]
          }
        }
        if (!isTargetSpeciesInitiated) {
          this.$store.commit('set', {targetSpecies: r})
        }
        return this.$store.state.targetSpecies
      },

      set (v) {
        this.$store.commit('set', {targetSpecies: v})
      }
    }
  },

  methods: {
    selectAllTargetTypes () {
      let r = {}
      for (let type of this.$store.getters.allTargetTypes) {
        r[type] = true
      }
      this.$store.commit('set', {targetTypes: r})
    },

    selectNoneTargetTypes () {
      let r = {}
      for (let type of this.$store.getters.allTargetTypes) {
        r[type] = false
      }
      this.$store.commit('set', {targetTypes: r})
    },

    selectAllTargetSpecies () {
      let r = {}
      for (let species of this.$store.getters.allTargetSpecies) {
        r[species] = true
      }
      this.$store.commit('set', {targetSpecies: r})
    },

    selectNoneTargetSpecies () {
      let r = {}
      for (let species of this.$store.getters.allTargetSpecies) {
        r[species] = false
      }
      this.$store.commit('set', {targetSpecies: r})
    },

    close () {
      this.$emit('input', false)
    },

    filter (task) {
      let v = this
      let newTask = JSON.parse(JSON.stringify(task))
      return newTask
    },

    applyAssayRange () {
      this.$store.commit('set', {assayRange: this.assayRange})
    }
  },

  mounted () {
    let r = {}
    let isAssayInitiated = true
    for (let type in this.allAssayTypes) {
      let assayType = this.allAssayTypes[type]
      if (!(type in r)) {
        r[type] = {}
      }
      for (let unit in assayType) {
        let values = assayType[unit]
        let mn = Math.min(...values)
        let mx = Math.max(...values)
        if (mn !== mx) {
          r[type][unit] = { type, active: true, allowNaN: false, range: [mn, mx], min: mn, max: mx, step: (mx - mn) / 20.0, unit }
          if (!(type in this.$store.state.assayRange) || !(unit in this.$store.state.assayRange[type])) {
            isAssayInitiated = false
          }
        }
      }
    }
    if (!isAssayInitiated) {
      this.$store.commit('set', {AssayRange: r})
      this.assayRange = r
    } else {
      this.assayRange = this.$store.state.assayRange
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


$control-color: #409EFF;

.filters-background {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  color: $font-grey;
}

.filters-content {
  background-color: #dadada;
  margin: 50px auto auto auto;
  font-size: 16px;
  width: 1100px;
}

.filters-head {
  background-color: white;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
}

.filters-title {
  margin: 0px auto 0px 10px;
}

.filters-close {
  margin: 0px 10px 0px auto;
  cursor: pointer;
}

.filters-body {
  padding: 10px 30px;
  max-height: 600px;
  overflow-y: auto;
}

.filter-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.filter-label {
  // width: 300px;
  // min-width: 300px;
  font-weight: 600;
  margin-right: 20px;
}

.filter-switch-select-all {
  cursor: pointer;
  float: left;
  margin: 5px 10px;
  padding: 3px;
  font-size: 10px;
}

.filter-switch-select-all:hover {
  text-decoration: underline;
}

.filter-switch {
  border-radius: 10px;
  cursor: pointer;
  float: left;
  margin: 5px 10px;
  padding: 3px;
  font-size: 10px;
}

.filter-switch-on {
  background-color: $theme-color;
  border: 1px solid $theme-color;
  color: white;
}

.filter-switch-off {
  background-color: white;
  border: 1px solid #85929e;
  color: black;
}

.filter-card {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  margin: 20px 30px 20px 30px;
}

.filter-card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.filter-activity {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 12px;
}

.filter-activity-row {
  margin-bottom: 5px;
  margin-left: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
}

.filter-activity-row.filter-activity-head {
  font-weight: 500;
}

.filter-activity-row.filter-activity-head >div {
}

.filter-activity-row.filter-activity-head .filter-activity-slider {
  width: 320px;
  min-width: 320px;
  margin-right: 20px;
}

.filter-activity-type {
  width: 120px;
  min-width: 120px;
  word-wrap: break-word;
}

.filter-activity-check {
  width: 80px;
  min-width: 80px;
  margin: 10px 0px;
}

.filter-activity-allow-nan {
  width: 120px;
  min-width: 120px;
}

.filter-activity-slider {
  width: 160px;
  min-width: 160px;
  margin-right: 20px;
}

.filter-activity-input {
  width: 75px;
  min-width: 75px;
}

.filter-databases {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.filter-databases >div {
  margin-right: 20px;
}

</style>
